import { makeStyles } from '@material-ui/core';

const useEditorStyles = makeStyles((theme) => ({
  editorWrapper: {
    height: 420,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${theme.palette.border.dark}`,
    background: theme.palette.bg.white,
    '& .quill': {
      flex: 1,
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
      background: theme.palette.bg.white,
    },
    '& .ql-toolbar.ql-snow': {
      flexShrink: 0,
      background: theme.palette.bg.whiteOff1,
      border: 'none',
      padding: '4px 8px',
      position: 'relative',
      zIndex: 2,
      boxShadow: 'none',
      marginTop: 4,
      marginBottom: 4,
    },
    '& .ql-container.ql-snow': {
      flex: 1,
      minHeight: 0,
      border: 'none',
      overflowY: 'auto',
      background: theme.palette.bg.white,
      position: 'relative',
      zIndex: 1,
    },
    '& .ql-container.ql-snow::before': {
      content: '""',
      position: 'absolute',
      top: -4,
      left: 0,
      right: 0,
      height: 4,
      background: theme.palette.bg.white,
      boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
      zIndex: 2,
      pointerEvents: 'none',
    },
    '& .ql-snow.ql-toolbar button, & .ql-toolbar.ql-snow button': {
      padding: '3px 6px',
      width: 28,
      height: 28,
    },
    '& .ql-toolbar .ql-stroke': { strokeWidth: 1.8 },
    '& .ql-toolbar .ql-thin': { strokeWidth: 0.9 },
    '& .ql-editor': {
      minHeight: '100%',
      fontFamily: "'Libre Franklin', sans-serif",
      color: theme.palette.text.primary,
      fontSize: '14px',
      fontWeight: 400,
    },
    '& .ql-editor.ql-blank::before': {
      color: '#A5A5A5',
      fontStyle: 'normal',
    },
    '& .ql-formats': {
      borderRight: `1px solid ${theme.palette.bg.whiteOff2}`,
      marginRight: '8px !important',
      paddingRight: 8,
    },
    '& .ql-toolbar button': { marginRight: 8 },
    '& .ql-formats:last-child': {
      borderRight: 'none',
      marginRight: '0 !important',
      paddingRight: 0,
    },
    '& .ql-tooltip': { display: 'none !important' },
  },
  calendarDescriptionEditor: {
    height: 150,
    '& .ql-editor': { minHeight: 'unset' },
  },
  disabled: {
    '& .ql-toolbar.ql-snow': {
      background: '#F5F5F5 !important',
      pointerEvents: 'none',
      cursor: 'not-allowed',
    },
    '& .ql-container.ql-snow': { background: '#F5F5F5 !important' },
    '& .ql-editor': {
      color: 'rgb(160, 154, 187) !important',
      cursor: 'not-allowed',
    },
  },
  borderHighlightML: {
    borderColor: `${theme.palette.alert.warn2} !important`,
    boxShadow: `0px 0px 4px ${theme.palette.alert.warn2}`,
  },
  snackbarBlock: {
    position: 'static',
    transform: 'none',
    marginBottom: 6,
    '& .MuiSnackbarContent-root': {
      minWidth: 0,
      maxHeight: 40,
      backgroundColor: theme.palette.text.grayColor,
    },
    '& .MuiSnackbarContent-message': { padding: '0' },
  },
  editorInner: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
  },
}));

export default useEditorStyles;
